<template>
  <div class="w-full h-full px-4 pb-5 box-border flex flex-col overflow-hidden">
    <header class="w-full py-1 text-right">
      <el-button type="primary" size="small" @click="bindHandle">添加维度</el-button>
    </header>
    <div class="flex-1 overflow-hidden">
      <data-table
        ref="dataTable"
        class="sms_table w-full h-full overflow-hidden"
        cell-class-name="truncate-table-cell-wrap"
        align="left"
        height="100%"
        :data="list"
        :loading="tableLoading"
        :columns="columns"
        :show-page="false"
        :show-tooltip="true"
        index
      >
        <template #action="{ row }">
          <el-button type="text" size="small" @click="editHandle(row)">编辑</el-button>
          <el-button type="text" size="small" class="ml-1" @click="removeHandle(row)">删除</el-button>
        </template>
      </data-table>
    </div>
  </div>
</template>

<script>
import { createPopup } from '@/assets/js/factory'
import DataTable from '@/components/base/DataTable'
import AddDimensionDialog from './AddDimensionDialog'
import { dimensionScoreColumns } from '../../config/dimension-score'
import { removeDimension } from '@/api/wenjuan/dimensionScore';

export default {
  name: 'DimensionSettingTable',
  components: {
    DataTable
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  inject: {
    topSource: {
      default: () => ({})
    }
  },
  data() {
    return {
      tableLoading: false,
      columns: dimensionScoreColumns,
      removeLoading: false,
    }
  },
  mounted() {
    this.topSource.onNextBefore = null;
  },
  methods: {
    bindHandle() {
      createPopup(AddDimensionDialog, {
        onConfirm: this.successHandle
      });
    },
    successHandle() {
      this.$emit('confirm');
    },
    editHandle(item) {
      createPopup(AddDimensionDialog, {
        onConfirm: this.successHandle,
        title: '编辑维度',
        submitType: 'edit',
        value: item.title,
      });
    },
    async removeHandle(item) {
      if (this.removeLoading) return;
      try {
        await this.$confirm(
          '点击确认，该维度不可恢复，绑定的题目也将清空，您确定要删除么？',
          '系统提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
      } catch (e) {
        return;
      }
      // 执行删除
      try {
        const req = [item.title];
        this.removeLoading = true;
        const res = await removeDimension(req);
        const { code, msg } = res.data || {};
        if (code === 0) {
          this.$message.success('删除维度成功');
          this.$emit('confirm');
        } else {
          this.$message.error(msg ?? '删除维度失败');
        }
      } catch (e) {
        this.$message.error('删除维度失败');
      } finally {
        this.removeLoading = false;
      }
    },
  }
}
</script>